import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { apiClientV2 } from '~/api/client';
import { SavedList } from '~/clientApi/savedLists.model';

interface Payload {
  id: string;
  name?: string;
  enabledControls?: string[];
}

export const useUpdateSavedList = () => {
  return useMutation<SavedList, AxiosError, Payload, SavedList>((payload) => {
    return apiClientV2.patch(
      `saved-lists/${payload.id}`,
      {
        name: payload.name,
        enabledControls: payload.enabledControls,
      },
      {
        headers: {
          'Content-Type': 'application/merge-patch+json',
        },
      },
    );
  });
};
